function clickableTooltip(tooltipName) {
    const tooltipEl = $('#' + tooltipName);
    let timeoutId;

    tooltipEl.tooltip({
        trigger: 'manual',
        html: true
    });

    tooltipEl.on('mouseenter', function() {
        tooltipEl.tooltip('show');
    }).on('mouseleave', function() {
        timeoutId = setTimeout(function() {
            tooltipEl.tooltip('hide');
        }, 200);  // Delay to allow user to move cursor to tooltip
    });

    $(document).on('mouseenter', '.tooltip', function() {
        clearTimeout(timeoutId); // clear the timeout if the user moves to the tooltip
    }).on('mouseleave', '.tooltip', function() {
        tooltipEl.tooltip('hide');
    });
}